function firstLetterToUpperCase(string_) {

    if (typeof string_ !== "string") {
        throw new TypeError(
            `Argument 'string_' must be of type 'string', got '${typeof string_}' instead!`
        )
    }

    return string_[0]?.toUpperCase() + string_.slice(1,);
}

export default {
    firstLetterToUpperCase
}